export const ru = {
    delete: 'Удалить'
};
